import { IsNumber } from 'class-validator';

export class SaleUnitCartAmountValidationRequestDto {
  @IsNumber()
  saleUnitCartId: number;

  @IsNumber()
  amount: number;
}
